window.script_path = (function () {
    var scripts = document.querySelectorAll( 'script[src]' );
    var currentScript = scripts[ scripts.length - 1 ].src;
    var currentScriptChunks = currentScript.split( '/' );
    var currentScriptFile = currentScriptChunks[ currentScriptChunks.length - 1 ];
    return currentScript.replace( currentScriptFile, '' );
})()+'../js/';

(function() {
    // Enable tooltips
    var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    var tooltipList = Array.prototype.slice.call(tooltipTriggerList).map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Add class to body when notifications are open
    var dropdowns = document.querySelectorAll('.dropdown');
    dropdowns.forEach(function(dropdown){
        dropdown.addEventListener('show.bs.dropdown', event => {
            var className = dropdown.getAttribute('data-bb-body-class');
            if (className) {
                document.body.classList.add(className);
            }
        })
        dropdown.addEventListener('hide.bs.dropdown', event => {
            var className = dropdown.getAttribute('data-bb-body-class');
            if (className) {
                document.body.classList.remove(className);
            }
        })
    })

    // Copy value to clipboard
    document.body.addEventListener('click', function(event) {
        if (event.target.closest('[data-toggle="copy-value"]')) {
            var target = event.target.closest('[data-toggle="copy-value"]');

            event.preventDefault();

            var temp = document.createElement("input");
            document.body.appendChild(temp);
            temp.value = target.getAttribute('data-copy-value');
            temp.select();
            document.execCommand("copy");
            document.body.removeChild(temp);


            target.classList.add('success');

            setTimeout(function(){
                target.classList.remove('success');
            }, 2000);
        }
    });

    document.addEventListener('DOMContentLoaded', scrollPageToBottomIfChatBox);
    window.addEventListener('load', scrollPageToBottomIfChatBox);
})();

function scrollPageToBottomIfChatBox() {
    var chatbox = document.querySelector('.form-message-mobile');
    if (!chatbox) {
        return true;
    }
    var display = window.getComputedStyle(chatbox).display;
    if (display === 'block') {
        window.scrollTo(0, document.body.scrollHeight);
    }
}